import React, { useMemo, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import debounce from 'lodash.debounce';
import { useSearchPages } from '../../../hooks/useSearchPages'; // Custom hook for fetching search results
import { useNavigate } from 'react-router-dom';

export default function Highlights() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  // Debounced input handling
  const handleInputChange = useMemo(
    () =>
      debounce((event, value) => {
        setSearchTerm(value);
      }, 300),  // Debounce input by 300ms
    []
  );

  // Use the custom hook to fetch data
  const { data: pageList = [], isLoading, error } = useSearchPages(searchTerm);

  const options = useMemo(() => {
    return pageList;
  }, [pageList]);

  return (
    <Autocomplete
      sx={{ width: 300 }}
      options={options} // Use data from the custom hook or fallback option
      getOptionLabel={(option) => option.title} // Adapt to your backend data structure
      onInputChange={handleInputChange} // Handles input changes
      loading={isLoading}
      noOptionsText={searchTerm === '' ? "Start typing to search..." : "No Page Found!"}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search Page"
          margin="normal"
          error={!!error}
          helperText={error ? "Failed to fetch results" : ""}
        />
      )}
      renderOption={(props, option, { inputValue }) => {
        const { key, ...restProps } = props; // Extract the key and spread the rest
        
        // Check if the option is the "No Page Found!!!" message
        if (option.id === -1) {
          console.log("mf")
          return (
            <li key={key} {...restProps}>
              <div style={{ color: 'red', fontWeight: 500 }}>
                {option.title}
              </div>
            </li>
          );
        }
      
        // For all other options, apply the matching and highlighting logic
        const matches = match(option.title, inputValue, { insideWords: true });
        const parts = parse(option.title, matches);
      
        return (
          <li key={key} {...restProps} onClick={() => {
            setSearchTerm(''); // Reset the search term
            navigate(`/page/content/${option.id}/${option.slug}`); // Navigate to the page
          }}>
            <div>
              {parts?.map((part, index) => (
                <span
                  key={index}
                  style={{
                    fontWeight: part.highlight ? 700 : 400,
                    color: part.highlight ? 'blue' : 'black',
                  }}
                >
                  {part.text}
                </span>
              ))}
            </div>
          </li>
        );
      }}
      
    />
  );
}
